<div class="p-5 text-center">
  <div (click)="handleClick($event, false)" id="stadium-map" #svgContainer></div> <!-- [hidden]="!planLoaded" -->
</div>

